<template>
    <div class="card municurve ice-wrap" >
        <div class="card-body">
            <div class="modal-header">
                <h5 class="card-title">Bid Info</h5>
                <p>{{bid.cusipDescription}}</p>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                    <i class="fas fa-times-circle"></i>
                </button>
            </div>
            <div class="card-text" v-bind:style=" bid ? 'display:block' : 'display: none;'">
                <ul>
                    <li>Executed ECN :<span>{{bid.successEcn == 'IBP' ? 'BondPoint' : bid.successEcn}}</span></li>
                    <!-- <li>Executed Time :<span>{{bid.bidSuccessAt ? moment(bid.bidSuccessAt).format("MM/DD/YYYY HH:mm:ss") : 'N/A'}}</span></li> -->
                    <li>Executed Time :<span>{{bid.bidSuccessAt ? moment_timezone(bid.bidSuccessAt).tz('America/New_York').format("MM/DD/YYYY HH:mm:ss") : 'N/A'}} EST</span></li>

                    <li>Executed {{bid.bidType == 'YIELD' ? 'Yield' : 'Price'}} :<span>{{bid.executedAmount ? bid.executedAmount : 'N/A'}}</span></li>
                    <li>Executed Quantity :<span>{{bid.executedQuantity ? bid.executedQuantity : 'N/A'}}</span></li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: 'bidinfo',
    props: ['bid'],
};
</script>